import CommonToggleContainer from "../Common/CommonToggleContainer";
import ToggleItem from "../Common/ToggleItem";
import AudioManager from "../Shared/AudioManager";
import NoticeData from "../Models/NoticeData";
import PopWindowManager from "../Shared/PopWindowManager";
const i18n = require('LanguageData');
const { ccclass, property } = cc._decorator;

@ccclass
export default class NoticeUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.WebView)
    wvContent: cc.WebView = null

    // @property(cc.Animation)
    // animation: cc.Animation = null
    private htmlStr: string = "";

    onLoad() {
        // 如果gameNode处于隐藏状态，则直接关掉公告界面，以免造成层级错位
        if (cc.find("Canvas/gameNode") && !cc.find("Canvas/gameNode").active) {
            PopWindowManager.popWindowArr = []
            this.node.destroy()
            return
        }

        this.wvContent.node.active = false
        // 处理超链接
        this.wvContent.setJavascriptInterfaceScheme("http")
        this.wvContent.setOnJSCallback(function (target, url) {
            cc.sys.openURL(url)
        }.bind(this))
    }

    start(): void {
        this.createToggles(NoticeData.getPopUpItems())
    }

    onEnable(): void {
        this.wvContent.node.active = true
        this.htmlStr && this.wvContent["_impl"].loadHTMLString(this.htmlStr)
        //this.wvContent["_impl"]._iframe.setBackgroundTransparent(true)
    }

    onDisable(): void {
        this.wvContent.node.active = false
    }

    onBtnClick(event, userData) {
        if (userData === "close") {
            AudioManager.playSound("close")
            this.wvContent.node.active = false
            //this.animation.play("exit_notice")
            PopWindowManager.openNext();
            this.node.destroy();
        }
    }

    onWebViewEvent(webView: cc.WebView, event: cc.WebView.EventType) {
        if (event === cc.WebView.EventType.LOADED) {
        }
    }

    onEnterAnimationEnd() {
    }

    onExitAnimationEnd() {
    }

    onSelectToggle(toggle: ToggleItem) {
        let htmlBefore = '<meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;" name="viewport" /><style>body{background:#313B8C;color: #FFFFFF;font-size: 15px;}</style><div style="width:100%;word-break:break-all;word-wrap:break-word;">'
        let htmlAfter = '</div>';
        this.htmlStr = htmlBefore + toggle.userData["content"] + htmlAfter;
        this.wvContent["_impl"].loadHTMLString(htmlBefore + toggle.userData["content"] + htmlAfter)
        //this.wvContent["_impl"]._iframe.setBackgroundTransparent(true)
    }

    private createToggles(cfgs) {
        cfgs.forEach(cfg => {
            if (cfg.messageType === 1) {
                this.toggleContainer.addDefaultToggle(cfg.title || i18n.t('task_text.announcement'), cfg)
            }
        });
    }
}
